<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مشخصات کلی شغل</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">عنوان شغل</label>
          <input
              type="text"
              class="form-control"
              placeholder="عنوان شغل را وارد کنید"
              v-model="jobDescription.job_title"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">رده شغل</label>
          <input
              type="text"
              class="form-control"
              placeholder="رده شغل را وارد کنید"
              v-model="jobDescription.job_grade"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">واحد سازمانی</label>
          <input
              type="text"
              class="form-control"
              placeholder="واحد سازمانی را وارد کنید"
              v-model="jobDescription.organizational_unit"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label fw-bold">مسئول مافوق</label>
          <input
              type="text"
              class="form-control"
              placeholder="مسئول مافوق را وارد کنید"
              v-model="jobDescription.supervisor"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    jobDescription: {
      get() {
        return this.$store.state.jobDescription.jobDescription;
      }
    },
  },
}
</script>